import { useSetAtom } from "jotai";
import {PhantomWalletModalAtom} from "../atoms";

const useGetPublicAddress = () => {
  const setDialog = useSetAtom(PhantomWalletModalAtom);

  const confirm = (title, message, confirmText = "Yes", cancelText = "Cancel") =>
    new Promise((resolve) => {
      setDialog({
        open: true,
        title,
        message,
        confirmText,
        cancelText,
        resolve,
      });
    });

  return confirm;
};

export default useGetPublicAddress;
